import { TweenMax } from 'gsap';
import { GameAudio } from '../../../Config/Audio';
import SoundManager from '../../../Sound/SoundManager';
import { Animation } from '../../Animations/Animation';
import { buttonPressAnimation, buttonReleaseAnimation } from '../../Animations/UIAnimations';
import Point = PIXI.Point;
import { IScrollViewItem } from '../ScrollView/IScrollViewItem';
import { disableWebGL } from '../../../Utils/Platform';

enum UIButtonEvents {
    Trigger = 'trigger',
}

export class UIButton extends PIXI.Container implements IScrollViewItem {
    public get enabled() {
        return this.isEnabled;
    }

    public set enabled(value: boolean) {
        this.setEnabled(value);
        this.isEnabled = value;
    }

    public static readonly events = UIButtonEvents;

    public originalScale: PIXI.Point;
    public bg: PIXI.Sprite;
    protected disableAnimation: Animation;
    private isEnabled: boolean = true;
    private wasDown: boolean;

    constructor(bgId: string, color: number = 0xffffff) {
        super();
        this.bg = new PIXI.Sprite(PIXI.utils.TextureCache[bgId]);
        this.bg.anchor.set(0.5);
        this.bg.tint = color;
        this.addChild(this.bg);
        this.interactive = true;
        this.buttonMode = true;
        this.addListeners();
        this.originalScale = new Point(this.scale.x, this.scale.y);
        this.createDisableAnimation();
    }

    public cleanUp() {
        this.removeAllListeners();
        TweenMax.killTweensOf(this.scale);
    }

    public setDragging(dragging: boolean): void {
        if (dragging) {
            this.pointerUpAnimation();
        }
    }

    public destroy(options?: PIXI.DestroyOptions | boolean): void {
        this.cleanUp();
        super.destroy();
    }

    protected pointerUpAnimation() {
        if (this.wasDown) {
            buttonReleaseAnimation(this, this.originalScale);
            this.wasDown = false;
        }
    }

    protected setEnabled(enabled: boolean) {
        if (this.enabled === enabled) {
            return;
        }
        if (disableWebGL()) {
            this.alpha = enabled ? 1 : 0.6;
        }
        if (enabled) {
            this.disableAnimation.reversed();
        } else {
            this.disableAnimation.play();
        }
    }

    private addListeners() {
        this.on('pointerupoutside', this.pointerUpAnimation);
        this.on('pointerout', this.pointerUpAnimation);
        this.on('pointerup', () => {
            if (this.wasDown) {
                this.emit(UIButton.events.Trigger, { currentTarget: this });
                SoundManager.playSound(GameAudio.TAP);
                this.pointerUpAnimation();
            }
        });
        this.on('pointerdown', () => {
            if (!this.originalScale) {
                this.originalScale = new Point(this.scale.x, this.scale.y);
            }
            buttonPressAnimation(this, 0.93, true);
            this.wasDown = true;
        });
    }

    protected createDisableAnimation() {
        const disableAnimation = (this.disableAnimation = new Animation({}));
        disableAnimation.add(
            TweenMax.to(this, 0.1, { pixi: { saturation: 0.2, brightness: 0.8 } })
        );
    }
}
